import { Box, Container } from "@mui/material";
import React from "react";
import { Trading } from "../../CommonPage/MarketFlow/Trading";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import WhyTradeForex from "../../CommonPage/WhyTradeForexs/WhyTradeForex";
import { PickPairs } from "../../CommonPage/PickPair/PickPairs";
import { PickPairsStock } from "../../CommonPage/PickPair/PickPairsStock";
import Wealth from "../../Componenets/Globalassets/Wealth";
import NewWealth from "../../Componenets/Globalassets/NewWealth";
import NewCommonity from "../../Componenets/Globalassets/NewCommonity";
import { useLanguage } from "../../context/LanguageContext";
import GlobalComon from "../../Componenets/Globalassets/GlobalComon";

export const Commonditity = () => {
  const { language, translations } = useLanguage();

  const cardData = [
    {
      heading: translations[language]?.cardsDataCommom?.title,
      logo: "/Images/comm1.png",
      description: translations[language]?.cardsDataCommom?.description,
    },
    {
      heading: translations[language]?.cardsDataCommom?.title1,
      logo: "/Images/comm4.png",
      description: translations[language]?.cardsDataCommom?.description1,
    },
    {
      heading: translations[language]?.cardsDataCommom?.title2,
      logo: "/Images/comm2.png",
      description: translations[language]?.cardsDataCommom?.description2,
    },
    {
      heading: translations[language]?.cardsDataCommom?.title3,
      logo: "/Images/comm3.png",
      description: translations[language]?.cardsDataCommom?.description3,
    },
  ];

  const Commonity = [
    {
      name: "COFFEE",
      spread: "1.2",
      img: "Images/Coffies.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Coffee",
    },
    {
      name: "COCOA",
      spread: "1.4",
      img: "Images/colaaaaa.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cocoa",
    },
    {
      name: "SOYBEAN",
      spread: "1.1",
      img: "Images/imli.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Soyabean",
    },
    {
      name: "COTTON",
      spread: "1.2",
      img: "Images/gobi.png",
      leverage: "1:100",
      lowSpread: "35:65",
      sub: "US Cotton",
    },
    // {
    //   name: "COFFEE",
    //   spread: "1.4",
    //   img: "Images/Coffies.png",
    //   leverage: "1:100",
    //   lowSpread: "35:65",
    //   sub: "US Cocoa",
    // },
    // {
    //   name: "COFFEE",
    //   spread: "1.1",
    //   img: "Images/Coffies.png",
    //   leverage: "1:100",
    //   lowSpread: "35:65",
    //   sub: "US Cocoa",
    // },
    // {
    //   name: "COFFEE",
    //   spread: "1.2",
    //   img: "Images/Coffies.png",
    //   leverage: "1:100",
    //   lowSpread: "35:65",
    //   sub: "US Cocoa",
    // },
  ];

  return (
    <Box>
      <Trading
      banner="Images/forexClean3.png"
        titleLine1={translations[language]?.commoditiesTrading?.titleLine1}
        active={translations[language]?.commoditiesTrading?.active}
        titleLine2={translations[language]?.commoditiesTrading?.titleLine2}
        subtitle={translations[language]?.commoditiesTrading?.subtitle}
      />
      <GlobalComon />
      <WhyTradeForex
        subtitle={translations[language]?.whyTradeSub}
        cardData={cardData}
      />
      <PickPairsStock
        Commonity={Commonity}
        title={translations[language]?.CommoditiesTile}
        subtitle={translations[language]?.CommoditiesTileDes}
      />
      <Container maxWidth="xl">
        <Box mt={10} mx={7}>
          <NewCommonity
            title={
              <>
                {translations[language]?.commonit} <br />
                {translations[language]?.commonit1}
              </>
            }
            subtitle={
              <>
                {translations[language]?.comment2} <br />
                {translations[language]?.comment3}
              </>
            }
          />{" "}
        </Box>
      </Container>
    </Box>
  );
};
//
